const GA_COOKIE_NAME = "_ga";
const VISIT_ID_FIELD = "CC_APP_VISIT_ID";

type ExtendedWindow = Window & {
    [VISIT_ID_FIELD]: string;
};

function getGACookie() {
    const name = GA_COOKIE_NAME + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        //eslint-disable-next-line eqeqeq
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        //eslint-disable-next-line eqeqeq
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export default function getUserIds() {
    const extendedWindow = (window as unknown) as ExtendedWindow;
    return {visitID: extendedWindow[VISIT_ID_FIELD], gaUserID: getGACookie()};
}
